var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchStreams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 13.333h13.334V4.167H3.333v9.166zm7.5 1.667v1.667h3.334v1.666H5.833v-1.666h3.334V15H2.493a.832.832 0 01-.826-.84V3.34c0-.464.38-.84.826-.84h15.014c.456 0 .826.374.826.84v10.82a.84.84 0 01-.826.84h-6.674z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/watch-streams.svg";
export { SvgWatchStreams as ReactComponent };